export default class RatingModifier {
  template: HTMLElement;

  /**
   *
   */
  constructor(template: HTMLElement) {
    this.template = template;
  }

  /**
   * Build the ratings
   */
  build(score: number): HTMLElement {
    const stars = this.template.getElementsByRef('star');
    for (let i = 0; i < stars.length; i++) {
      if (i < score) {
        stars[i].classList.remove('text-grey');
        stars[i].classList.add('text-secondary');
      } else {
        stars[i].classList.remove('text-secondary');
        stars[i].classList.add('text-grey');
      }
    }
    return this.template;
  }
}
